declare function fbq(...args: any[]): void;

export const fbqActionStart = () => {
    if (typeof fbq !== 'undefined') {
        fbq('trackCustom', 'QuizStart', {
            event_category: 'quiz',
            event_label: 'Quiz Started'
        });
    }
}

export const fbqActionClickNext = () => {
    if (typeof fbq !== 'undefined') {
        fbq('trackCustom', 'QuizNextQuestion', {
            event_category: 'quiz',
            event_label: 'Next Question'
        });
    }
}

export const fbqActionResult = () => {
    if (typeof fbq !== 'undefined') {
        fbq('trackCustom', 'QuizResultToContactForm', {
            event_category: 'quiz',
            event_label: 'Result to Contact Form'
        });
    }
}

export const fbqActionThanks = () => {
    if (typeof fbq !== 'undefined') {
        fbq('track', 'Lead', {
            event_category: 'form',
            event_label: 'Thank You Page'
        });
    }
}